import { render, staticRenderFns } from "./PaymentOrderList.vue?vue&type=template&id=1d06e7a8&"
import script from "./PaymentOrderList.vue?vue&type=script&lang=js&"
export * from "./PaymentOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports